import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class LanguageSelector extends Vue {
  @Prop() public type!: string;
  public language: String = 'Castellano';
  public languages: String[] = ['Castellano', 'Valenciano'];
  public locale: String[] = ['es', 'va'];

  public created() {
    console.log(this.type);
  }

  public changeLanguage(language: string) {
    this.language = language;
    this.selectLanguage();
  }

  public selectLanguage() {
    const index = this.languages.indexOf(this.language.toString());
    this.$root.$i18n.locale = this.locale[index].toString();
  }

  public srcImage(language: string) {
    return '../../../public/assets/flags/Valenciano.png';
  }
}